module.exports = {"name":"bh-mixin-sdk","version":"0.2.53","description":"wisedu mixin sdk","main":"lib/BH_MOBILE.js","files":["lib","src"],"scripts":{"dist":"rm -rf lib && webpack","prepublish":"npm run dist"},"keywords":["sdk","JavaScript"],"author":"Wisedu","license":"ISC","devDependencies":{"babel-core":"^6.17.0","babel-loader":"^6.2.5","babel-plugin-transform-runtime":"^6.15.0","babel-preset-es2015":"^6.14.0","babel-preset-stage-2":"^6.13.0","babel-runtime":"^6.0.0","json-loader":"^0.5.7","kanpai":"^0.7.0","webpack":"^1.13.2"},"dependencies":{"axios":"^0.16.1","bh-mobile-sdk":"^0.3.5","jsonp":"^0.2.1"}}


//////////////////
// WEBPACK FOOTER
// ./package.json
// module id = 115
// module chunks = 0